export default function PricesCombined($filter) {
    'ngInject';

        return function(value, initCurrency) {
            const prices = !_.isArray(value) ? [value] : value;

            if (!prices || !prices.length) {
                return '';
            }

            let currencyDiffers = false;
            const currency = initCurrency || prices[0].CurrencyCode;
            const combined = prices.reduce(function(init, price) {
                    currencyDiffers = currencyDiffers || (currency !== price.CurrencyCode);
                    if (price.Amount >= 0) {
                        init.push($filter('currencyByCode')(price.Amount, price.CurrencyCode));
                    }
                    return init;
                }, []);

            return currencyDiffers
                ? '(' + combined.join(' + ') + ')'
                : '';
        };
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/services/priceFilter.js